﻿import { DataGridPro } from "@mui/x-data-grid-pro";
import React, { useEffect, useState } from "react";

import LoadingBar from "@/components/shared/LoadingBar";

const ShepDataGridPro = (params) => {
  const { isDataLoaded, secondsToStall, ...gridParams } = params;
  const [animationComplete, setAnimationComplete] = useState(false);

  useEffect(() => {
    if (!isDataLoaded) {
      //catch loading grid during filtering
      setAnimationComplete(false);
    }
  }, [isDataLoaded]);
  return (
    <>
      <DataGridPro
        className="ShepDataGridPro"
        {...gridParams} //must be first as following props will overwrite values
        rows={animationComplete ? gridParams.rows : []}
        slots={{ ...gridParams.slots, loadingOverlay: LoadingBar }}
        slotProps={{
          ...gridParams.slotProps,
          loadingOverlay: {
            isDataLoaded: isDataLoaded,
            setFinishedAnimation: setAnimationComplete,
            secondsToStall,
          },
        }}
        loading={!animationComplete}
      />
    </>
  );
};

export default ShepDataGridPro;
